import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SITE_DISPLAY_RRP } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import VoucherItem from "@components/VoucherManager/VoucherItem";
import "./style.scss";

const VoucherItems = ({
                          items = [],
                          selectedItems = [],
                          setQuantity = () => {},
                          purchasableItemKey = () => {},
                          isGiftingMode = false
                      }) => {
    const { whiteLabel } = useContext(ApplicationContext);
    const cashbackFlag = whiteLabel?.subscriber_group?.cashback_flag;
    const displayPrice = whiteLabel?.subscriber_group?.display_price;
    const displayCashback = cashbackFlag && displayPrice === SITE_DISPLAY_RRP;

    return (
        <>
            {items.map((item, i) => {
                const idKey = purchasableItemKey(item);

                return (
                    <VoucherItem
                        key={idKey}
                        item={item}
                        index={i}
                        selectedItems={selectedItems}
                        setQuantity={setQuantity}
                        idKey={idKey}
                        isGiftingMode={isGiftingMode}
                        cashbackFlag={displayCashback}
                        displayPrice={displayPrice}
                    />
                );
            })}
        </>
    );
};

VoucherItems.propTypes = {
    items: PropTypes.array.isRequired,
    selectedItems: PropTypes.array.isRequired,
    setQuantity: PropTypes.func.isRequired,
    purchasableItemKey: PropTypes.func.isRequired,
    isGiftingMode: PropTypes.bool,
};

export default VoucherItems;
